import { DataAttributeDefinitions } from 'scrivito'

import { pisaDocumentProjectRelationDataClass } from './Pisa/pisaDocumentProjectRelationDataClass'

const attributes: DataAttributeDefinitions = {}

export const DocumentProjectRelation =
  pisaDocumentProjectRelationDataClass(attributes)
